export const QRCODE_TOTEM_TYPE = {
  TOTEM_TICKET: 0,
  TOTEM_RECHARGE: 1,
}